import React, { useState, useEffect, useContext } from 'react';
import { X, Shield } from 'lucide-react';
import { AuthContext } from '../contexts/AuthContext';
import { TwoFactorSetup, TwoFactorStatus } from './TwoFactorAuth';
import axios from 'axios';
import { API } from '../lib/axiosClient';

/**
 * SecuritySettingsDialog — Zeigt 2FA-Status und Verwaltungsoptionen.
 * Wird über die Sidebar geöffnet.
 */
const SecuritySettingsDialog = ({ isOpen, onClose }) => {
  const { user } = useContext(AuthContext);
  const [totpEnabled, setTotpEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen && user) fetchStatus();
  }, [isOpen, user]);

  const fetchStatus = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/2fa/status`);
      setTotpEnabled(res.data.enabled);
    } catch (e) { /* ignore */ }
    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm" data-testid="security-dialog-overlay">
      <div className="w-full max-w-md bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl overflow-hidden" data-testid="security-dialog">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-700">
          <div className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-emerald-500" />
            <h2 className="text-base font-semibold text-white">Sicherheitseinstellungen</h2>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors" data-testid="security-dialog-close">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-5 text-white">
          {loading ? (
            <div className="py-8 text-center text-sm text-slate-400">Lade...</div>
          ) : totpEnabled ? (
            <TwoFactorStatus
              onDisabled={() => { setTotpEnabled(false); }}
            />
          ) : (
            <TwoFactorSetup
              onComplete={() => { setTotpEnabled(true); fetchStatus(); }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SecuritySettingsDialog;
